var _defs, _mask, _circle, _mask2, _g, _path, _mask3, _g2, _path2, _mask4, _g3, _circle2, _mask5, _g4, _polygon, _mask6, _g5, _polygon2, _mask7, _g6, _mask8, _g7, _path3, _mask9, _g8, _g9, _mask10, _g10, _g11, _mask11, _g12, _g13, _mask12, _g14, _path4, _mask13, _g15, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 215.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 39.404789,
    y1: 65.114182,
    x2: 87.249611,
    y2: 92.593346,
    id: "linearGradient-15",
    gradientTransform: "scale(0.98734641,1.0128158)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: "0%",
    id: "stop13"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.02,
    offset: "100%",
    id: "stop15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.33333,50.666667 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 c 0,15.386666 6.8666667,29.16 17.693333,38.446666 L 11.613333,99.64 V 108 c 0,0.73333 0.6,1.33333 1.333334,1.33333 0.246666,0 0.473333,-0.0667 0.673333,-0.18 L 20.853333,104.98 26.5,95.206667 c 7.18,3.906666 15.413333,6.126663 24.166667,6.126663 8.753333,0 16.986666,-2.219997 24.173333,-6.126663 L 80.486667,104.98 87.72,109.15333 c 0.2,0.11334 0.426667,0.18 0.673333,0.18 0.733334,0 1.333334,-0.6 1.333334,-1.33333 v -8.36 l -6.08,-10.526667 c 10.82,-9.286666 17.686663,-23.06 17.686663,-38.446666 z",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 15.828767,
    cy: 14.563382,
    fx: 15.828767,
    fy: 14.563382,
    r: 124.73273,
    gradientTransform: "matrix(0.96271972,0,0,1.0387239,152.88977,3.8205887)",
    id: "radialGradient-30",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.1,
    offset: "0%",
    id: "stop25"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%",
    id: "stop27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#radialGradient-30",
    id: "radialGradient692",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.96271972,0,0,1.0387239,84.771709,88.526978)",
    cx: 15.828767,
    cy: 14.563382,
    fx: 15.828767,
    fy: 14.563382,
    r: 124.73273
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g690",
    transform: "matrix(1.9736843,0,0,1.9736843,-167.9705,-175.3822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    id: "use32",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#45EF8A",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    cx: 50.666668,
    cy: 50.666668,
    r: 50.666668
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3",
    id: "use38",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 50.666667,100.66667 c 27.76,0 50.293333,-22.32667 50.646663,-50.000003 h 0.02 c 0,27.98 -22.686663,50.666663 -50.666663,50.666663 C 22.686667,101.33333 0,78.646667 0,50.666667 H 0.02 C 0.37333333,78.34 22.906667,100.66667 50.666667,100.66667 Z",
    id: "Shape",
    fillOpacity: 0.2,
    fill: "#263238",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g53",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5",
    id: "use46",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 50.666667,0 C 22.686667,0 0,22.686667 0,50.666667 H 101.33333 C 101.33333,22.686667 78.646667,0 50.666667,0 Z",
    id: "path51",
    fill: "#3DDC84",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7",
    id: "use55",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g58"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "circle60",
    fill: "#3DDC84",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    cx: 50.666668,
    cy: 42.666668,
    r: 6.6666665
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g71",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9",
    id: "use64",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g67"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon69",
    fillOpacity: 0.05,
    fill: "#263238",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    points: "101.33333,50.666667 0,50.666667 0,50 101.33333,50 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g80",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11",
    id: "use73",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g76"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon78",
    fillOpacity: 0.05,
    fill: "#ffffff",
    fillRule: "nonzero",
    mask: "url(#mask-12)",
    points: "101.33333,51.333333 0,51.333333 0,50.666667 101.33333,50.666667 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g89",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13",
    id: "use82",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g85"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon87",
    fill: "url(#linearGradient-15)",
    fillRule: "nonzero",
    mask: "url(#mask-14)",
    points: "39.886667,50.666667 12.946667,109.33333 101.33333,109.33333 101.33333,64 56,18.666667 45.333333,26.666667 ",
    style: {
      fill: "url(#linearGradient-15)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g105",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-18",
    id: "use98",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 50.666667,0.66666667 c 27.76,0 50.293333,22.32666633 50.646663,50.00000033 h 0.02 C 101.33333,22.686667 78.646667,0 50.666667,0 22.686667,0 0,22.686667 0,50.666667 H 0.02 C 0.37333333,22.993333 22.906667,0.66666667 50.666667,0.66666667 Z",
    id: "path103",
    fillOpacity: 0.2,
    fill: "#ffffff",
    fillRule: "nonzero",
    mask: "url(#mask-19)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g124",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-20",
    id: "use107",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g110"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.333333,45.333333)",
    id: "g121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.113333,5.3333333 H 5.7933333 L 37.153333,59.646667 44.386667,63.82 c 0.2,0.113333 0.426666,0.18 0.673333,0.18 0.733333,0 1.333333,-0.6 1.333333,-1.333333 v -8.36 z",
    id: "path113",
    fill: "#D7EFFE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.113333,5.3333333 H 5.7933333 L 37.153333,59.646667 44.386667,63.82 c 0.2,0.113333 0.426666,0.18 0.673333,0.18 0.733333,0 1.333333,-0.6 1.333333,-1.333333 v -8.36 z",
    id: "path115",
    fill: "#BDBDBD",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon117",
    fillOpacity: 0.2,
    fill: "#ffffff",
    fillRule: "nonzero",
    points: "46.386667,54.306667 18.113333,5.3333333 17.726667,5.3333333 46.386667,54.973333 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.053333,63.333333 c -0.246666,0 -0.473333,-0.06667 -0.673333,-0.18 L 37.146667,58.98 6.18,5.3333333 H 5.7933333 L 37.153333,59.646667 44.386667,63.82 c 0.2,0.113333 0.426666,0.18 0.673333,0.18 0.733333,0 1.333333,-0.6 1.333333,-1.333333 V 62 c -0.0067,0.733333 -0.606666,1.333333 -1.34,1.333333 z",
    id: "path119",
    fillOpacity: 0.1,
    fill: "#212121",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g143",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22",
    id: "use126",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g129"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g141",
    mask: "url(#mask-23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6,45.333333)",
    id: "g139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.333333,5.3333333 C 71.333333,20.06 59.393333,32 44.666667,32 c -4.38,0 -8.513334,-1.06 -12.16,-2.933333 L 44.666667,8 l 1.54,-2.6666667 h -12.32 L 5.6066667,54.306667 v 8.36 C 5.6066667,63.4 6.2066667,64 6.94,64 7.1866667,64 7.4133333,63.93333 7.6133333,63.82 l 7.2333337,-4.173333 12.32,-21.333334 c 5.22,2.773334 11.173333,4.353334 17.5,4.353334 C 65.286667,42.666667 82,25.953333 82,5.3333333 Z",
    id: "path133",
    fill: "#D7EFFE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.886667,5.3333333 5.6066667,54.306667 v 0.666666 L 34.273333,5.3333333 Z M 44.666667,32 c -4.38,0 -8.513334,-1.06 -12.16,-2.933333 v 0.666666 c 3.646666,1.873334 7.78,2.933334 12.16,2.933334 14.726666,0 26.666666,-11.94 26.666666,-26.666667 H 81.98 C 81.986667,5.78 82,5.56 82,5.3333333 H 71.333333 C 71.333333,20.06 59.393333,32 44.666667,32 Z",
    id: "path135",
    fillOpacity: 0.4,
    fill: "#ffffff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.206667,5.3333333 H 45.82 L 32.5,28.4 v 0.666667 z m 35.773333,0 C 81.62,25.64 65.06,42 44.666667,42 c -6.326667,0 -12.28,-1.58 -17.5,-4.353333 L 14.846667,58.98 7.6133333,63.153333 c -0.2,0.113334 -0.4266666,0.18 -0.6733333,0.18 -0.7333333,0 -1.3333333,-0.6 -1.3333333,-1.333333 v 0.666667 C 5.6066667,63.4 6.2066667,64 6.94,64 7.1866667,64 7.4133333,63.93333 7.6133333,63.82 l 7.2333337,-4.173333 12.32,-21.333334 c 5.22,2.773334 11.173333,4.353334 17.5,4.353334 C 65.286667,42.666667 82,25.953333 82,5.3333333 Z",
    id: "path137",
    fillOpacity: 0.1,
    fill: "#212121",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g158",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-24",
    id: "use145",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g148"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g156",
    mask: "url(#mask-25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.333333,13.333333)",
    id: "g154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33.333333,13.333333 H 26.666667 V 5.3333333 H 16 V 13.333333 H 9.3333333 c -2.2,0 -4,1.8 -4,4 v 20 l 13.1733337,13.16 c 0.726666,0.72 1.72,1.173334 2.826666,1.173334 C 22.44,51.666667 23.44,51.22 24.16,50.493333 l 13.173333,-13.16 v -20 c 0,-2.2 -1.8,-4 -4,-4 z M 21.333333,36 c -3.68,0 -6.666666,-2.986667 -6.666666,-6.666667 0,-3.68 2.986666,-6.666666 6.666666,-6.666666 3.68,0 6.666667,2.986666 6.666667,6.666666 C 28,33.013333 25.013333,36 21.333333,36 Z",
    id: "path152",
    fill: "#073042",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g167",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-26",
    id: "use160",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g163"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 62.666667,26.666667 H 56 v 0.666666 h 6.666667 c 2.2,0 4,1.8 4,4 v -0.666666 c 0,-2.2 -1.8,-4 -4,-4 z M 56,18.666667 H 45.333333 v 0.666666 H 56 Z m -10.666667,8 h -6.666666 c -2.2,0 -4,1.8 -4,4 v 0.666666 c 0,-2.2 1.8,-4 4,-4 h 6.666666 z m 5.333334,22.666666 C 46.986667,49.333333 44,46.346667 44,42.666667 v 0.666666 C 44,47.013333 46.986667,50 50.666667,50 c 3.68,0 6.666666,-2.986667 6.666666,-6.666667 v -0.666666 c 0,3.68 -2.986666,6.666666 -6.666666,6.666666 z",
    id: "path165",
    fillOpacity: 0.1,
    fill: "#ffffff",
    fillRule: "nonzero",
    mask: "url(#mask-27)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g176",
    transform: "translate(85.105049,88.860311)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-28",
    id: "use169",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g172"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 50.666667,36 c 3.68,0 6.666666,2.986667 6.666666,6.666667 V 42 c 0,-3.68 -2.986666,-6.666667 -6.666666,-6.666667 C 46.986667,35.333333 44,38.32 44,42 v 0.666667 C 44,38.986667 46.986667,36 50.666667,36 Z m 2.826666,27.16 c -0.726666,0.72 -1.72,1.173333 -2.826666,1.173333 C 49.56,64.333333 48.56,63.886667 47.84,63.16 L 34.666667,50 v 0.666667 L 47.84,63.826667 C 48.566667,64.546667 49.56,65 50.666667,65 c 1.106666,0 2.106666,-0.446667 2.826666,-1.173333 l 13.173334,-13.16 V 50 Z",
    id: "path174",
    fillOpacity: 0.1,
    fill: "#212121",
    fillRule: "nonzero",
    mask: "url(#mask-29)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 186.43838,139.52698 c 0,-27.98 -22.68667,-50.666669 -50.66667,-50.666669 -27.98,0 -50.666661,22.686669 -50.666661,50.666669 0,15.38666 6.86666,29.16 17.693331,38.44666 l -6.080001,10.52667 v 8.36 c 0,0.73334 0.6,1.33334 1.33333,1.33334 0.24667,0 0.47334,-0.0667 0.67334,-0.18 l 7.233331,-4.17334 5.64667,-9.77333 c 7.17999,3.90667 15.41333,6.12667 24.16666,6.12667 8.75333,0 16.98667,-2.22 24.17333,-6.12667 l 5.64667,9.77333 7.23333,4.17334 c 0.2,0.11333 0.42667,0.18 0.67334,0.18 0.73333,0 1.33333,-0.6 1.33333,-1.33334 v -8.36 l -6.08,-10.52667 c 10.82,-9.28666 17.68667,-23.06 17.68667,-38.44666 z",
    id: "path178",
    fill: "url(#radialGradient-30)",
    fillRule: "nonzero",
    style: {
      fill: "url(#radialGradient692)",
      stroke: "none",
      strokeWidth: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.69ccbbbf9700a42bb4e73d4826b991d5.svg";
export { ForwardRef as ReactComponent };